import { useState, useEffect, useCallback } from 'react';

interface UseDynamicHeightParams {
  tabBarHeight?: number;
  customHeight?: number;
  designWidth?: number;
}

export const useDynamicHeight = ({ tabBarHeight = 64, customHeight = 0, designWidth = 375 }: UseDynamicHeightParams = {}) => {
  const [height, setHeight] = useState<number>(0);

  const calculateHeight = useCallback(() => {
    const currentDeviceWidth = window.innerWidth;
    const ratio = currentDeviceWidth / designWidth;
    const calculatedTabBarHeight = Math.round(tabBarHeight * ratio);
    const calculatedCustomHeight = Math.round(customHeight * ratio);
    const viewportHeight = window.innerHeight;
    return viewportHeight - calculatedTabBarHeight - calculatedCustomHeight;
  }, [tabBarHeight, customHeight, designWidth]);

  useEffect(() => {
    const handleResize = () => {
      setHeight(calculateHeight());
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [calculateHeight]);

  return height;
};
